import merge from 'deepmerge'
import PropTypes from 'prop-types'
import React from 'react'

const styles = {
  alignItems: 'stretch',
  borderStyle: 'solid',
  borderWidth: 0,
  boxSizing: 'border-box',
  display: 'flex',
  flexBasis: 'auto',
  flexDirection: 'column',
  flexShrink: 0,
  margin: 0,
  padding: 0,

  // fix flexbox bugs
  minHeight: 0,
  minWidth: 0
}

const View = ({ style = {}, children, ...props }) => {
  return <div style={merge(styles, style)} {...props}>{children}</div>
}

View.propTypes = {
  style: PropTypes.object,
  children: PropTypes.node
}

export default View
